export * from './password.component';